/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import {
  ORDERS_URL,
} from "constants/url.constant";

import { API } from "api";
import { setError } from "../Indicator";

export const SET_PIECES_LIST = "SET_PIECES_LIST";
export const REQUEST_SHIPMENT_ORDER_PIECES = "REQUEST_SHIPMENT_ORDER_PIECES";
export const RESET = "RESET";

export const resetToInitialState = () => ({
  type: RESET
});

export const setPiecesList = (data) => {
  return {
    type: SET_PIECES_LIST,
    payload: data
  };
};

export const getOrderPieces = (orderId, { page, limit }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPMENT_ORDER_PIECES });
    try {
      const res = await API.get(`${ORDERS_URL}/${orderId}/pieces?page=${page}&limit=${limit}`);
      dispatch(setPiecesList(res));
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

export const getMissingPieceIds = (orderId) => {
  return async (dispatch) => {
    try {
      return await API.get(`${ORDERS_URL}/${orderId}/pieces/missing`);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  rows: [],
  totalRows: 0,
  order: null
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case RESET:
      return initialState;
    case SET_PIECES_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    case REQUEST_SHIPMENT_ORDER_PIECES:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    default:
      return state;
  }
}
